import React from "react";
import { useNavigate } from "react-router-dom";
import { formatDate, isAllowedToReturn } from "../../utils/commonHelper";
import { FiUser, FiHome } from "react-icons/fi";
import { FaTag, FaTicketAlt } from "react-icons/fa";
import { FaCreditCard, FaReceipt, FaCheckCircle } from "react-icons/fa";
import GeneralButton from "../../common/GeneralButton";
import CustomAlert from "../../common/CustomAlert";
import { Alert } from "react-bootstrap";
const statusColors = {
  0: "bg-orange text-white",
  1: "bg-quaternary text-white",
  2: "bg-[#888] text-white",
  3: "bg-orange text-white",
};

const paymentStatusColors = {
  Paid: "bg-green text-white",
  Unpaid: "bg-red-500 text-white",
  Pending: "bg-yellow text-primary",
};

const OrderDetails = ({ order }) => {
  const navigate = useNavigate();

  return (
    <div className="mt-6 flex flex-col gap-8 bg-[#DEE2DD]/40 rounded-[15px] p-10 lg:px-10 w-full">
      {/* A. Order Summary */}
      <div className="grid grid-cols-1 gap-6">
        <div className="bg-white rounded-[15px] px-4 py-2">
          <h3 className="text-24pt border-b border-b-gray pb-2 mb-2">
            Order Summary
          </h3>
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 text-sm text-gray-800 py-2">
            <p className="text-18pt">
              <span className="font-mono">Order ID:</span>{" "}
              <span className="">{order?.orderId}</span>
            </p>
            <p className="text-18pt">
              <span className="font-mono">Date of Order:</span>{" "}
              <span className="">{formatDate(order?.createdAt)}</span>
            </p>
            <p className="text-18pt">
              <span className="font-mono">Total Amount:</span>{" "}
              <span className=" text-18pt text-green mt-2 ">
                {" "}
                {Number(order?.totalAmount || 0).toFixed(2)} AED
              </span>
            </p>
            <p className="text-18pt flex items-center gap-2">
              <span className="font-mono">Status:</span>{" "}
              <span
                className={`px-2 py-0.5 rounded-[5px] text-12pt  ${
                  statusColors[order?.orderStatus]
                }`}
              >
                {order?.orderStatus === "0"
                  ? "Pending"
                  : order?.orderStatus === "1"
                  ? "Delivered"
                  : order?.orderStatus === "2"
                  ? "Cancelled"
                  : "Returned"}
              </span>
            </p>
          </div>
          {order?.orderStatus === "2" && (
            <>
              <div className="bg-orange/15 px-4 py-1 rounded-md shadow-sm mb-3 mt-1">
                <h4 className="text-18pt text-orange mb-1">Admin Comments</h4>
                <p className="text-16pt font-mono">
                  {order?.adminComments || "No reason provided."}
                </p>
              </div>
            </>
          )}
          {order?.orderStatus === "1" && (
            <>
              <div className="bg-quaternary/15 px-4 py-1 rounded-md shadow-sm mb-3 mt-1">
                <h4 className="text-18pt text-quaternary mb-1">Admin Comments</h4>
                <p className="text-16pt font-mono">
                  {order?.adminComments || "No reason provided."}
                </p>
              </div>
            </>
          )}
        </div>
        {/* B. Payment Information */}

        <div
          title="Click  to view payment details"
          className="space-y-3 bg-white rounded-[15px] px-4 py-5 shadow-sm cursor-pointer"
          onClick={() => navigate(`/account/payments/${order?.payment?._id}`)}
        >
          <h3 className="text-24pt border-b border-gray pb-2 mb-3 flex items-center gap-2">
            Payment Information
          </h3>

          {/* 💳 Payment Details Grid */}
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-3 text-sm text-gray-800 leading-relaxed items-start">
            <div className="grid grid-cols-1 gap-3">
              {order?.discountAmount?.$numberDecimal > 0 && (
                <>
                  <p className="mb-0 text-18pt">
                    <span className="font-mono text-gray-600">
                      Subtotal (Before discount):
                    </span>{" "}
                    {Number(
                      order?.subTotalBeforeDiscount?.$numberDecimal || 0
                    ).toFixed(2)}{" "}
                    AED
                  </p>

                  {/* Discount */}
                  {order?.discountAmount?.$numberDecimal && (
                    <p className="mb-0 text-18pt">
                      <span className="font-mono text-gray-600">
                        Coupon Discount:
                      </span>{" "}
                      -{Number(order.discountAmount.$numberDecimal).toFixed(2)}{" "}
                      AED
                    </p>
                  )}
                </>
              )}
              <p className="mb-0 text-18pt">
                <span className="font-mono text-gray-600">
                  Subtotal{" "}
                  {order?.discountAmount?.$numberDecimal > 0 && (
                    <span>(After discount)</span>
                  )}
                  :
                </span>{" "}
                {Number(order?.subTotal || 0).toFixed(2)} AED
              </p>
              {/* Shipping */}
              <p className="mb-0 text-18pt">
                <span className="font-mono text-gray-600">Shipping:</span>{" "}
                {Number(order?.shippingCharges || 0) > 0
                  ? `${Number(order.shippingCharges).toFixed(2)} AED`
                  : "Free"}
              </p>

              {/* VAT */}
              <p className="mb-0 text-18pt">
                <span className="font-mono text-gray-600">VAT:</span>{" "}
                {Number(order?.vatAmount?.$numberDecimal || 0).toFixed(2)} AED
              </p>

              {/* Total */}
              <p className="mb-0 text-18pt">
                <span className="font-mono">Total Amount:</span>{" "}
                <span className=" text-18pt text-green mt-2 ">
                  {Number(order?.totalAmount || 0).toFixed(2)} AED
                </span>
              </p>
            </div>
            <div className="grid grid-cols-1 gap-3">
              <p className="mb-0 text-18pt">
                <span className="font-mono text-gray-600">Method:</span>{" "}
                Credit/Debit Card
              </p>
              {/* {order?.payment?.stripePaymentId && (
                <p className="mb-0 text-18pt">
                  <span className="font-mono text-gray-600">
                    Transaction ID:
                  </span>{" "}
                  {order.payment.stripePaymentId}
                </p>
              )} */}
              {order?.payment?.date && (
                <p className="mb-0 text-18pt">
                  <span className="font-mono text-gray-600">Date:</span>{" "}
                  {formatDate(order?.payment?.date)}
                </p>
              )}
              {order?.invoiceUrl && (
                <p className="mb-0 text-18pt">
                  <span className="font-mono text-gray-600">Invoice:</span>{" "}
                  <a
                    href={order.invoiceUrl}
                    className="text-primary hover:underline flex items-center gap-1"
                    download
                  >
                    <FaReceipt /> Download
                  </a>
                </p>
              )}
              {order?.appliedCoupon && (
                <div className="flex items-center gap-3 border border-dashed border-orange-400 text-orange-700 bg-orange-50 rounded-[8px] px-5 py-2 w-fit shadow-sm">
                  <FaTicketAlt className="text-orange-500 " />
                  <div className="flex flex-col text-18pt">
                    <span className="">
                      Coupon Applied: {order?.appliedCoupon?.couponCode}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* 🎟️ Coupon Section */}
        </div>
      </div>

      {/* C. Products in Order */}
      <div className="space-y-2 bg-white rounded-[15px] px-4 py-4">
        <h3 className="text-24pt border-b border-b-gray pb-2 mb-2 capitalize">
          Product(s) Ordered{" "}
        </h3>
        <div className="flex flex-col divide-y divide-gray">
          {order?.orderedItems?.map((product, idx) => (
            <div
              key={idx}
              className={`grid gap-3 ${
                order?.orderStatus != "1"
                  ? "md:grid-cols-[3fr_1fr] 1xl:grid-cols-[2fr_1fr]"
                  : product?.productReturnRequest?._id
                  ? "md:grid-cols-[3fr_1fr] 1xl:grid-cols-[2fr_1fr]"
                  : isAllowedToReturn(order?.createdAt)
                  ? "md:grid-cols-[3fr_1fr] 1xl:grid-cols-[2fr_1fr_0.6fr]"
                  : "md:grid-cols-[3fr_1fr] 1xl:grid-cols-[2fr_1fr]"
              } py-3 items-center`}
            >
              <div className="flex items-center gap-3">
                <img
                  src={
                    process.env.REACT_APP_BACKEND_URL +
                    "public/" +
                    product?.product?.image
                  }
                  alt={product?.product?.title}
                  onError={(e) => {
                    e.currentTarget.src = require("../../../assets/images/link.png");
                  }}
                  className="w-20 h-20 object-cover rounded bg-gray"
                />
                <div className="flex flex-col ">
                  <p className=" text-gray-900 text-18pt">
                    {product?.product?.title}
                  </p>

                  <p className="text-18pt text-quaternary font-mono mt-1">
                    Qty: {product.quantity}
                  </p>
                </div>
              </div>
              <div className="text-18pt text-gray-900 mt-2 sm:mt-0 text-right ml-6 text-nowrap">
                <p className="font-mono text-18pt">{product.price} AED each</p>
                <p className="font-sans text-20pt text-orange mt-1 ">
                  {product.price * product.quantity} AED
                </p>
              </div>
              {order?.orderStatus === "1" &&
                isAllowedToReturn(order?.createdAt) &&
                !product?.productReturnRequest?._id && (
                  <div className="md:col-span-full 1xl:col-span-1 flex items-center justify-end">
                    <GeneralButton
                      className="font-mono px-2 text-18pt mt-2 py-1 transition"
                      onClick={() =>
                        navigate(
                          `/account/orders/return/${order._id}/${product?.productId}`
                        )
                      }
                      text="Return Product"
                      title="Click to return or replace product"
                      bgColor="#CC9965"
                      icon={null}
                    />
                  </div>
                )}
              {order?.orderStatus === "1" &&
                product?.productReturnRequest?._id &&
                product?.productReturnRequest?.status === "0" && (
                  <div className="col-span-full flex items-start justify-start mt-2 font-mono text-orange text-right text-18pt">
                    Product Return Requested
                  </div>
                )}
              {order?.orderStatus === "1" &&
                product?.productReturnRequest?._id &&
                (product?.productReturnRequest?.status === "1" ||
                  product?.productReturnRequest?.status === "2") && (
                  <div className="col-span-full mt-3">
                    <Alert
                      className={`relative rounded-md shadow-sm transition-all duration-300  px-5 py-3 ${
                        product?.productReturnRequest?.status === "1"
                          ? "border border-quaternary bg-quaternary/10 text-quaternary"
                          : "border border-orange bg-orange/10 text-orange"
                      }`}
                      role="alert"
                    >
                      <div className="flex items-start gap-3">
                        <div>
                          <h6 className="text-base tracking-wide mb-1">
                            Product Return{" "}
                            <span
                              className={`${
                                product?.productReturnRequest?.status === "1"
                                  ? "text-quaternary"
                                  : "text-orange"
                              }`}
                            >
                              {product?.productReturnRequest?.status === "1"
                                ? "Accepted"
                                : "Rejected"}
                            </span>
                          </h6>
                          <p className="text-sm leading-snug font-mono text-gray-700">
                            {product?.productReturnRequest?.adminComments}
                          </p>
                        </div>
                      </div>
                    </Alert>
                  </div>
                )}
            </div>
          ))}
        </div>
        <h3 className="border-t border-t-gray pt-4 mt-3 text-right space-y-1">
          {/* 🧾 Final Total */}
          <div className="text-20pt  text-gray-800 mt-0">
            Sub Total:{" "}
            <span className="font-sans text-green text-20pt">
              {Number(
                order?.subTotalBeforeDiscount?.$numberDecimal || 0
              ).toFixed(2)}{" "}
              AED
            </span>
          </div>
        </h3>
      </div>

      {/* D. Delivery & Tracking Info */}
      {order?.shippingAddress && (
        <div className="bg-white rounded-[15px] p-6 shadow-md space-y-6">
          <h3 className="text-2xl  border-b border-gray pb-3">
            Delivery Address
          </h3>

          <div className="flex flex-col sm:flex-row sm:justify-between gap-6">
            {/* <div className="flex flex-col items-start sm:items-center bg-[#F9F9F9] rounded-lg p-4 flex-1">
            <span className="text-gray-600 text-base  mb-2">
              Estimated Delivery
            </span>
            <span className="px-3 py-1 bg-tertiary text-white rounded-full  text-sm">
              {order?.eta}
            </span>
          </div> */}

            <div className="flex flex-col xl:flex-row  rounded-lg p-4 flex-1 gap-6">
              {/* 👤 User Info */}
              <div className="flex flex-col flex-1 space-y-2">
                <div className="flex items-center gap-2 text-gray-900 font-medium">
                  <FiUser className="text-green text-4xl" />
                  <div className="ml-4 text-gray-700 text-18pt space-y-1">
                    <p className="text-18pt">
                      {order?.shippingAddress?.firstName}{" "}
                      {order?.shippingAddress?.lastName}
                    </p>
                    <p className="flex flex-wrap gap-1 font-mono">
                      <span>{order?.shippingAddress?.email}</span>
                      <span className="text-gray-400">|</span>
                      <span>{order?.shippingAddress?.phone}</span>
                    </p>
                  </div>
                </div>
              </div>

              {/* 🏠 Address Info */}
              <div className="flex flex-col flex-1 space-y-2">
                <div className="flex items-center gap-2 text-gray-900 font-medium">
                  <FiHome className="text-green text-4xl" />
                  <div className="ml-4 text-gray-800 text-18pt leading-relaxed">
                    <p className="text-18pt">
                      {[
                        order?.shippingAddress?.addressLine1,
                        order?.shippingAddress?.addressLine2,
                        order?.shippingAddress?.area,
                        order?.shippingAddress?.landmark,
                        order?.shippingAddress?.city,
                        order?.shippingAddress?.state,
                        order?.shippingAddress?.country,
                      ]
                        .filter(Boolean)
                        .join(", ")}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/*          
          <div className="flex flex-col items-start sm:items-center bg-[#F9F9F9] rounded-lg p-4 flex-1">
            <span className="text-gray-600 text-base  mb-2">
              Tracking Status
            </span>
            <span
              className={`px-3 py-1 rounded-full  text-sm ${"bg-quaternary text-white"}`}
            >
              {order?.deliveryStatus}
            </span>
          </div> */}
          </div>
        </div>
      )}

      {/* E. Actions */}
      <div>
        <div className="flex flex-wrap gap-3 justify-end">
          {/* <GeneralButton
            className="font-mono px-2 py-0  transition"
            onClick={() => navigate(`/account/orders/cancel/${order.id}`)}
            text="Cancel Order"
            title="Click to cancel this order"
            bgColor="#30160E"
          /> */}

          {/* {order?.orderStatus === "1" && (
            <>
              <GeneralButton
                className="font-mono px-2 py-0 transition"
                onClick={() => navigate(`/account/orders/return/${order.id}`)}
                text="Return / Replace"
                title="Click to return or replace products"
                bgColor="#30160E"
              />
              <GeneralButton
                className="font-mono px-2 py-0  transition"
                onClick={() => navigate(`/account/orders/review/${order._id}`)}
                text="Leave Review"
                title="Click to add your review"
                bgColor="#CC9965"
              />
            </>
          )} */}
          {order?.invoiceUrl && (
            <GeneralButton
              onClick={order?.invoiceUrl}
              className="font-mono px-2 py-0  transition"
              download
              title="Click to download invoice"
              text="Download Invoice"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;
